const female = "FEMALE"
const male = "MALE"

const gender = {
    female: female,
    male: male
}

const genderLables = {
    [gender.female]: "נקבה",
    [gender.male]: "זכר"
}

const genderHebrewKeys = {
    ["נקבה"]: gender.female,
    ["זכר"]: gender.male
}

const genderOptions = [{ id: "MALE", name: "זכר" }, { id: "FEMALE", name: "נקבה" }]

// export { female, male }
export { genderHebrewKeys, genderLables, genderOptions }
export default gender
